/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/stop'
export default icon
